import React from 'react';

const PostBacksContext = React.createContext({});
PostBacksContext.displayName = 'PostBacksContext';

export default PostBacksContext;
